import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { grey } from '../assets/colors.js';
import { Montserrat } from '../assets/fonts.js';

var _templateObject;
var Badge = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 15px;\n  color: #fff;\n  padding: 4px 15px;\n  box-shadow: 0 5px 10px 0 rgba(180, 151, 90, 0.15);\n  width: auto;\n  margin: 5px;\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #ffffff;\n  white-space: nowrap;\n"])), function (props) {
  return props.color || grey;
}, Montserrat);
Badge.displayName = "Badge";
Badge.propTypes = {
  color: PropTypes.string
};

export { Badge as default };
